
import Chart from 'chart.js/src/chart.js'
import 'chartjs-funnel/src/chart.funnel.js'
import './chart-funnel.extend.js'
riot.tag2('chart', '  <canvas></canvas>\n', 'chart,[riot-tag="chart"],[data-is="chart"]{ display: inline-block; width: 100%; }', '', function(opts) {
'use strict';

var _this = this;

var self = this;
self.chart = null;

Chart.defaults.global.responsive = true;

self.one('updated', function () {
    drawChart();

    self.on('updated', function () {
        destroyChart();
        drawChart();
    });
});

self.on('loaded', function (c) {
    _this.on('unmount', function () {
        c.destroy();
    });
});

var chartTypes = ['bar', 'line', 'radar', 'polar', 'pie', 'doughnut', 'funnel'];

var drawChart = function drawChart() {
    if (!opts.data) opts.data = { labels: [], datasets: [] };
    if (!opts.options) opts.options = {};

    opts.options.animation = { duration: 0 };

    var ctx = self.root.querySelector('canvas').getContext('2d');
    self.chart = new Chart(ctx, {
        type: chartTypes.indexOf(opts.type) !== -1 ? opts.type : 'bar',
        data: opts.data,
        options: opts.options
    });

    self.trigger('loaded', self.chart);
};

var destroyChart = function destroyChart() {
    self.chart.destroy();
};
});


// WEBPACK FOOTER //
// ./components/chart/chart.tag